import styles from './CartColumn.module.scss'
import React, { useMemo } from 'react'
import classNames from 'classnames'

type Props = {
  children: React.ReactNode
  className?: string,
  textAlign?: 'left' | 'right' | 'center'
}

const CartColumn = ({ children, className = '', textAlign = 'left' }: Props) => {

  const alignItems = useMemo(() => {
    switch (textAlign) {
      case 'center':
        return 'center'
      case 'right':
        return 'flex-end'
      case 'left':
        return 'flex-start'
      default:
        return 'flex-start'
    }
  }, [textAlign])

  const extraStyle = {
    textAlign: textAlign,
    alignItems: alignItems,
  }

  return (
    <div style={extraStyle} className={classNames(styles.component, className)}>
      {children}
    </div>
  )
}

export default CartColumn
